function ss_bundle_update_add_to_cart() {
  // Find the form
  let $form = $('.quick-add-drawer[aria-hidden="false"] .js-product-form-main').first();
  if ($form.length === 0) {
    $form = $('.js-product-form-main:not(.quick-add-drawer .js-product-form-main)').first();
  }

  // Find the price
  let $price = $('.quick-add-drawer[aria-hidden="false"] .product-info__price').first();
  if ($price.length === 0) {
    $price = $('.product-info__price:not(.quick-add-drawer .product-info__price)').first();
  }

  // Disable submit while working
  $form.find('button[type="submit"]').prop('disabled', true);

  // Removing existing hidden inputs related to items
  $form.find('input[name="id"]').remove(); // Remove ID
  $form.find('input[name="quantity"]').remove(); // Remove Quantity
  $form.find('input[name="product-id"]').remove(); // Remove Product ID
  $form.find('input[name^="items["]').remove(); // Remove previous inputs if any
  
  let isError = false; // Track if there's an error
  let errorMessage = ''; // Error Message
  let toSubmit = []; // Store selections and quantities
  let listingPrice = 0; // Initialize listing price to 0

  $('.ss-product-bundle').each(function() {
    const $bundle = $(this);
    const selectId = $bundle.attr('id');
    const $qtyInput = $(`#${selectId}-quantity`);
    
    if ($qtyInput.length === 0) {
      console.log(`Quantity input field #${selectId}-quantity not found.`);
      isError = true;
      return;
    }

    const selectedOption = $bundle.find('option:selected');
    const optionQty = parseInt(selectedOption.data('quantity'), 10);
    const inventoryDisable = selectedOption.data('inventory_disable') === true;
    const dataPrice = parseFloat(selectedOption.data('price'));
    
    if (optionQty !== 0 || inventoryDisable) {
      const inputQty = parseInt($qtyInput.val(), 10);
      
      if (inputQty > optionQty) {
        errorMessage = `Input quantity ${inputQty} exceeds available quantity for option.`;
        console.log(errorMessage);
        isError = true;
        listingPrice += dataPrice * inputQty;
        return;
      }

      // Only add if the select value is not 0 and there's something to submit
      if ($bundle.val() !== "0" && inputQty > 0) {
        toSubmit.push({ selectId: $bundle.val(), qty: inputQty });
        listingPrice += dataPrice * inputQty;
      }
    }
  });

  // Error handling
  if (toSubmit.length === 0) {
    isError = true;
    console.log('No valid selections to submit.');
  }

  if (listingPrice > 0)
  {
    $price.prop('hidden', false).find('.price__current').text(new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(listingPrice));
  }
  else
  {
    $price.prop('hidden', true);
  }
  if (isError) {
    if (errorMessage)
    {
      $form.find('.js-form-error').prop('hidden', false).text(errorMessage);
    }
    return;
  }
  else
  {
    const bundleIdTimestamp = Date.now();
    toSubmit.forEach((item, index) => {
      if (item.selectId && item.qty > 0) { // Step 5: Only add if variant and quantity are set
        $form.append(`<input type="hidden" name="items[${index}][id]" value="${item.selectId}">`);
        $form.append(`<input type="hidden" name="items[${index}][quantity]" value="${item.qty}">`);
        $form.append(`<input type="hidden" name="items[${index}]properties[_bundle_id]" value="${bundleIdTimestamp}">`);
      }
    });
    $form.find('button[type="submit"]').prop('disabled', false);
    $form.find('.js-form-error').prop('hidden', true);
  }
}

